export const MYINVESTMENTS_TABLE_SUCCESS = 'MYINVESTMENTS/TABLE_SUCCESS'
export const MYINVESTMENTS_TABLE_FAILURE = 'MYINVESTMENTS/TABLE_FAILURE'